import { TransformationDefinitionDTO } from "../DTO/transformationDefinitionDTO";
import { BasicRequest } from "./basicRequest";

export class UpdateTransformationDefinitionRequest extends BasicRequest{
   
    public transformationDefinition! : TransformationDefinitionDTO;
    
    constructor(){
        super()
    }
}